import { Heading1, ParagraphNoSpace } from 'src/components/atoms/Typography'
import {
  FullWidthContainer,
  FullWidthContainerBackgroundColor
} from 'src/components/layouts/Container'
import { SanityPageComponent } from 'src/components/layouts/Page/SanityPage'
import { Text } from 'src/components/molecules/sanity/Content'
import { FeaturedProjectsSectionRebrand } from 'src/components/organisms/FeaturedProjectsSectionRebrand'

import { SpeciesSection } from './SpeciesSection'

export const NativeTrees: SanityPageComponent = ({ data }) => {
  return (
    <FullWidthContainer
      backgroundColor={FullWidthContainerBackgroundColor.linen}
      className='px-5 md:px-0! py-0!'
    >
      <div className='flex flex-col gap-5 md:gap-10 pt-10! md:pt-[60px]! md:pb-[100px] pb-5'>
        <div className='flex flex-col gap-[10px]'>
          <Heading1 className='m-0!'>{data?.hero?.heading}</Heading1>
          {data?.hero?.tagline ? (
            <ParagraphNoSpace className='text-[20px] font-medium'>
              <Text value={data?.hero?.tagline} />
            </ParagraphNoSpace>
          ) : null}
        </div>
        <SpeciesSection />
        <FeaturedProjectsSectionRebrand />
      </div>
    </FullWidthContainer>
  )
}
